/**
 * Cross-tab upload state via localStorage.
 * The tab that is uploading writes progress here; other tabs read it and listen
 * for the "storage" event to show the same progress.
 */

const STORAGE_KEY = "expert_i_dicom_uploads";

export { STORAGE_KEY };

export function getStoredUploads() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

export function setStoredUpload(jobRequestId, data) {
  const key = String(jobRequestId);
  const prev = getStoredUploads();
  prev[key] = {
    percent: data.percent,
    status: data.status,
    timeRemaining: data.timeRemaining,
    error: data.error,
  };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prev));
  } catch (_) {
    // Ignore quota or disabled storage
  }
}

export function removeStoredUpload(jobRequestId) {
  const key = String(jobRequestId);
  const prev = getStoredUploads();
  delete prev[key];
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prev));
  } catch (_) {
    // Ignore
  }
}

export function getStoredUpload(jobRequestId) {
  const all = getStoredUploads();
  return all[String(jobRequestId)] || null;
}
